import Service from 'react-reservice';

import { ESymbolCategory } from '@aqx-core/common/api/market';
import { EOrderType } from '@aqx-core/common/api/order';

export interface IAssetsFilterServiceContext {
  loading: boolean; // Initial loading state
  symbolTypeList: ESymbolCategory[];
  availableOrderTypes: EOrderType[];
}

const defaultContext: IAssetsFilterServiceContext = {
  loading: true,
  symbolTypeList: [],
  availableOrderTypes: []
};

class AssetsFilterService extends Service<IAssetsFilterServiceContext> {
  constructor() {
    super();
    this.context = defaultContext;
  }

  setLoading = (loading: boolean) => {
    this.context.loading = loading;
  };

  setSymbolCategories = (categories: ESymbolCategory[]) => {
    this.context.symbolTypeList = categories;
  };

  setAvailableOrderTypes = (orderTypes: EOrderType[]) => {
    this.context.availableOrderTypes = orderTypes;
  };
}

export const assetsFilterService = new AssetsFilterService();
